import { financeAPI } from "../../axios";

export const actions = {
     // DepartmentPlanningBudgetItem
    AddDepartmentPlanningBudgetItem(context, data){
        return financeAPI.post(`DepartmentPlanningBudgetItem/Add`, data);
    },
    UpdateDepartmentPlanningBudgetItem(context, data){
        return financeAPI.put(`DepartmentPlanningBudgetItem/${data.id}`, data);
    },
    RemoveDepartmentPlanningBudgetItem(context, data){
        return financeAPI.delete(`DepartmentPlanningBudgetItem/${data}`);
    },
    GetSingleDepartmentPlanningBudgetItem(context, data){
        return financeAPI.get(`DepartmentPlanningBudgetItem/${data}`);
    },
    GetAllDepartmentPlanningBudgetItem(context, data){
        return financeAPI.get(`DepartmentPlanningBudgetItem/All/${data.departmentId}/${data.cycle}`);
    },
    GetAllBudgetItem(context, data){
        return financeAPI.get(`DepartmentPlanningBudgetItem/BudgetItem/All/${data}`);
    },
    UpdateAmountBudgetItem(context, data){
        return financeAPI.put(`DepartmentPlanningBudgetItem/Amount/${data.id}/${data.amount}`);
    },
    GetBalanceBudgetItem(context, data){
        return financeAPI.get(`DepartmentPlanningBudgetItem/Balance/All/${data.departmentId}/${data.cycle}`);
    },
    GetBalanceBudgetItemById(context, data){
        return financeAPI.get(`DepartmentPlanningBudgetItem/Balance/${data}`);
    }
}